import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductRiseLabelAsync,
  deleteProductRiseLabelAsync,
  editProductStyleAsync,
  editProductRiseLabelAsync,
  getProductStyleAsync,
  getProductRiseLabelAsync,
} from "../../../../store/services/productInfoServices";
const RiseLabel = () => {
  const dispatch = useDispatch();
  const {
    getProductRiseLabelStatus,
    getProductRiseLabelError,
    getProductRiseLabelData,
    addProductRiseLabelStatus,
    addProductRiseLabelData,
    addProductRiseLabelError,

    editProductRiseLabelStatus,
    editProductRiseLabelError,
    editProductRiseLabelData,

    deleteProductRiseLabelData,
    deleteProductRiseLabelStatus,
    deleteProductRiseLabelError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductRiseLabelAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductRiseLabelData?.length
    ? getProductRiseLabelData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedRiseLabel, setSelectedRiseLabel] = useState();
  const [addRiseLabelMode, setAddRiseLabelMode] = useState(false);
  const [addRiseLabelData, setAddRiseLabelData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedRiseLabel", selectedRiseLabel);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductRiseLabelStatus === asyncStatus.SUCCEEDED) {
      setAddRiseLabelMode(false);
      setSaveDisabled(true);
      setAddRiseLabelData();
    }
  }, [, addProductRiseLabelStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductRiseLabelAsync(selectedRiseLabel?.rise_label_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductRiseLabelStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedRiseLabel();
    }
  }, [, deleteProductRiseLabelStatus]);
  useEffect(() => {
    if (editProductRiseLabelStatus === asyncStatus.SUCCEEDED) {
      setSelectedRiseLabel();
      setEditMode(false);
    }
  }, [, editProductRiseLabelStatus]);
console.log("getProductRiseLabelData",getProductRiseLabelData,editProductRiseLabelData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this RiseLabel?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Rise Label"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Rise Label Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddRiseLabelMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addRiseLabelMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addRiseLabelMode || !selectedRiseLabel}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddRiseLabelMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addRiseLabelMode || !selectedRiseLabel}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductRiseLabelStatus === asyncStatus.LOADING ||
                  editProductRiseLabelStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addRiseLabelData) {
                    dispatch(addProductRiseLabelAsync(addRiseLabelData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedRiseLabel, ...editData };
                    delete a.id;
                    dispatch(editProductRiseLabelAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "rise_label_id", headerName: "ID", flex: true },
                  {
                    field: "rise_label_name",
                    headerName: "Rise Label Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedRiseLabel(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductRiseLabelStatus === asyncStatus.IDLE ||
                  getProductRiseLabelStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addRiseLabelMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "RiseLabel:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddRiseLabelData({
                            ...addRiseLabelData,
                            rise_label_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddRiseLabelData({
                            ...addRiseLabelData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedRiseLabel ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedRiseLabel?.rise_label_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "RiseLabel:",
                    comp: (
                      <InputComp
                        key={selectedRiseLabel?.rise_label_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            rise_label_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedRiseLabel?.rise_label_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedRiseLabel?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedRiseLabel?.is_active ? true : false
                        }
                        checked={selectedRiseLabel?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any rise label</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductRiseLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductRiseLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductRiseLabelError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductRiseLabelError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedRiseLabel(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedRiseLabel(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default RiseLabel;
